import { render } from "./BaseSelectCompact.vue?vue&type=template&id=54ef5a28&scoped=true"
import script from "./BaseSelectCompact.vue?vue&type=script&lang=js"
export * from "./BaseSelectCompact.vue?vue&type=script&lang=js"

import "./BaseSelectCompact.vue?vue&type=style&index=0&id=54ef5a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ef5a28"]])

export default __exports__